import styles from './index.less';
import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import TagEditorModalStore from './store';

/* PSD 标签槽位列锚点（标签1~标签4 布局占位）：动态候选项按列复用锚点名，便于 DevTools 核对（POSTER-MANUAL-001） */
const TAG_SLOT_COLUMN_ANCHORS = ['标签1', '标签2', '标签3', '标签4'];

const TagEditorModal = ({ onClose, store }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      {/* 忠实转换自 psd-to-html/mo-poster 的 弹窗-标签选择（group-46）图层子树；
          画布级定位交由 ModalContainer 承载，内部子节点保留 PSD 相对坐标。
          标签1~标签4 为 PSD 布局占位（占位图内烙印文案不可复用），运行时按候选池以
          相同槽位尺寸/间距复刻胶囊样式动态渲染，选中/禁用态为运行时 class（spec Task 5）。 */}
      <div className={styles.root} data-name="弹窗-标签选择">
        <div className={styles.layer76} data-name="弹窗背景底栏" />
        <div className={styles.group47} data-name="主体">
          <div className={styles.group48} data-name="标签按钮">
            {/* 草稿等运行期变化数据一律读取弹窗 Store（observable），不依赖一次性 props 快照 */}
            {store.candidateTags.map((tag, index) => {
              const isSelected = store.isCandidateSelected(tag);
              const isDisabled = store.isCandidateDisabled(tag);
              const rarity = store.rarityOf(tag);

              return (
                <button
                  key={tag}
                  type="button"
                  className={cx(styles.tagItem, styles[`tagItemR${rarity}`], isSelected && styles.tagItemSelected, isDisabled && styles.tagItemDisabled)}
                  data-name={TAG_SLOT_COLUMN_ANCHORS[index % TAG_SLOT_COLUMN_ANCHORS.length]}
                  aria-pressed={isSelected}
                  disabled={isDisabled}
                  onClick={() => store.toggleDraftTag(tag)}
                >
                  {tag}
                </button>
              );
            })}
          </div>
        </div>

        <button className={cx(styles.layer81, styles.hitArea)} data-name="确认修改按钮" type="button" aria-label="确认修改标签" onClick={store.confirmDraft} />
        <button
          className={cx(styles.layer82, styles.hitArea)}
          data-name="弹窗关闭按钮"
          type="button"
          aria-label="关闭标签选择弹窗"
          onClick={store.onClickClose}
        />
        <div className={styles.layer83} data-name="可选择标签 2/3">
          可选择标签&#32;{store.draftTags.length}/3
        </div>
        {/* 已选标签描述区（交互-6-10，2026-09-21 需求）：计数标题与确认按钮之间，
            按 draftTags 进队顺序逐行展示达成条件描述——「标签名：」加粗 + 描述常规字重，随选择联动增减 */}
        {store.draftTags.length ? (
          <div className={styles.tagDescList}>
            {store.draftTags.map(tag => (
              <div key={tag} className={styles.tagDescItem}>
                <strong>{tag}：</strong>
                {store.descOf(tag)}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </ModalContainer>
  );
};

export default wrapStore(TagEditorModal, TagEditorModalStore);
